
























































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { Validations } from 'vuelidate-property-decorators'
import { validationMixin } from 'vuelidate'
import { required, minLength, maxLength, requiredIf } from 'vuelidate/lib/validators'
import Button from '@/app/ui/components/Button/index.vue'
import DropdownSelect from '@/app/ui/components/DropdownSelect/index.vue'
import TextInput from '@/app/ui/components/TextInput/index.vue'
import DateTimePicker from '@/app/ui/components/DateTimePicker/index.vue'
import MultiselectV2 from '@/app/ui/components/MultiselectV2/index.vue'
import LoadingOverlay from '@/app/ui/components/LoadingOverlay/index.vue'
import IconWarningTriangle from '@/app/ui/assets/icon_warning_triangles.vue'
import ModalConfirm from '../../components/Modals/ModalConfirm/index.vue'
import ModalSuccess from '../../components/Modals/ModalSuccess/index.vue'
import { POS } from '@/domain/entities/POS'

import {
  EnumCourierTypeParams,
  EnumOfferMethodType,
  EnumStatus,
  ICourierParams,
  IGeoAddressParams,
  IOptions,
  IOptionsCreate,
  EnumDedicatedType,
  IPOSParams,
  IForm,
} from '@/app/infrastructures/misc/Constants/manageCourierDedicated'
import NestedMultiSelect, {
  ILocation,
} from '../../components/NestedMultiSelect/index.vue'
import dedicatedController from '@/app/ui/controllers/ManageCourierDedicatedController'
import courierController from '@/app/ui/controllers/ManageCourierController'
import { ManageCourierAdjustSaldo } from '@/domain/entities/ManageCourier'
import { GeoAddress } from '@/domain/entities/ManageCourierDedicated'
import { Utils } from '@/app/infrastructures/misc'
import IconPlus from "@/app/ui/assets/ics_f_plus_circle.vue";
import { ManageCourierDedicatedApiRequestV2 } from '@/data/payload/api/ManageCourierDedicatedRequest'
import POSController from '@/app/ui/controllers/POSController';
import IconTrash from '@/app/ui/assets/ics_f_trash.vue'
import CheckBox from '@/app/ui/components/CheckBox/index.vue'

@Component({
  mixins: [validationMixin],
  components: {
    Button,
    DropdownSelect,
    TextInput,
    DateTimePicker,
    MultiselectV2,
    LoadingOverlay,
    IconWarningTriangle,
    ModalConfirm,
    ModalSuccess,
    NestedMultiSelect,
    IconPlus,
    IconTrash,
    CheckBox
  },
})
class CreateManageCourierDedicatedPage extends Vue {
  POSController = POSController
  dedicatedController = dedicatedController
  courierController = courierController
  modalConfirmVisible = false
  modalSuccessVisible = false
  modalDescription =
    'Pastikan data nama wilayah & kurir & untuk area telah sesuai'
  courierOptionsMP: Array<IOptions> = []
  courierOptionsCA: Array<IOptions> = []
  courierOptionsClient: Array<IOptions> = []
  courierOptionsCorporateMobil: Array<IOptions> = []
  courierOptionsCorporateMotor: Array<IOptions> = []
  geoAddressMainList: Array<ILocation> = []
  posOptionsMP: IOptions[] = [];
  posOptionsCA: IOptions[] = [];
  posOptionsClient: IOptions[] = [];
  posOptionsCorporateMobil: IOptions[] = [];
  posOptionsCorporateMotor: IOptions[] = [];
  dedicatedMP: IOptionsCreate[] = [];
  dedicatedCA: IOptionsCreate[] = [];
  dedicatedClient: IOptionsCreate[] = [];
  dedicatedCorporateMobil: IOptionsCreate[] = [];
  dedicatedCorporateMotor: IOptionsCreate[] = [];

  offerMethodOptions: Array<IOptions> = [
    {
      label: "Auto-Assign",
      value: EnumOfferMethodType.AUTO_ASSIGN,
    },
    { label: "Offer", value: EnumOfferMethodType.OFFER },
  ]

  statusOptions: Array<IOptions> = [
    { label: "Aktif", value: true },
    { label: "Non-Aktif", value: false },
  ]

  form: IForm = {
    areaName: '',
    location: [],
    courierMP: [],
    courierCA: [],
    courierClient: [],
    courierCorporateMobil: [],
    courierCorporateMotor: [],
    offerMethod: this.offerMethodOptions[-1],
    status: this.statusOptions[-1],
  }

  hasChanged: Record<string, boolean> = {
    areaName: false,
    location: false,
    offerMethod: false,
    status: false,
  }

  courierParameters: ICourierParams = {
    page: 1,
    perPage: 10,
    q: '',
    sortBy: 'ASC',
    driverType: '',
    courierStatus: 'ACTIVE',
  }

  posParameters: IPOSParams = {
    page: 1,
    perPage: 10,
    search: "",
    filterStatus: "ACTIVE"
  }

  geoAddressParameters: IGeoAddressParams = {
    search: '',
  }

  created(): void {
    this.fetchMaxConfig()
    this.fetchGeoAddresses()
    this.fetchCourier(true, EnumCourierTypeParams.POS)
    this.fetchPOS(true);
  }

  get courierParams(): Record<string, string | number> {
    return { ...this.courierParameters }
  }

  get geoAddressParams(): Record<string, string> {
    return { ...this.geoAddressParameters }
  }

  get isFormValid() {
    return [
      !this.$v.form.$invalid,
      !this.$v.dedicatedMP.$invalid,
      !this.$v.dedicatedCA.$invalid,
      !this.$v.dedicatedClient.$invalid,
      !this.$v.dedicatedCorporateMobil.$invalid,
      !this.$v.dedicatedCorporateMotor.$invalid,
    ].every(v => v);
  }

  private fetchMaxConfig(): void {
    this.dedicatedController.getMaxConfig()
  }

  private fetchGeoAddresses(): void {
    this.dedicatedController.getGeoAddress(this.geoAddressParams)
  }

  private fetchCourier(
    reset?: boolean,
    driverType?: EnumCourierTypeParams
  ): void {
    if (reset) this.courierParameters.page = 1

    if (driverType === EnumCourierTypeParams.POS) {
      this.courierParameters.driverType = EnumCourierTypeParams.POS
    } else if (driverType === EnumCourierTypeParams.KVP) {
      this.courierParameters.driverType = EnumCourierTypeParams.KVP
    }

    this.courierController.getManageCourierListAdjustSaldo(this.courierParams)
  }

  private fetchPOS(reset?: boolean) {
    if (reset) this.posParameters.page = 1;
    this.POSController.getPOSData(this.posParameters as any)
  }

  private filterCourier = Utils.debounce(() => {
    this.fetchCourier(true, EnumCourierTypeParams.POS)
  }, 400)

  private filterPOS = Utils.debounce(() => {
    this.fetchPOS(true)
  }, 400)

  public onAddCourier(field: EnumDedicatedType): void {
    if (this[field].length < dedicatedController.maxConfig) {
      this[field].push({
        open: false,
        assignee: "COURIER",
        value: undefined,
        specialHandling: false
      })
    }
  }

  public onAddPOS(field: EnumDedicatedType): void {
    if (this[field].length < dedicatedController.maxConfig) {
      this[field].push({
        open: false,
        assignee: "POS",
        value: undefined,
        specialHandling: false
      })
    }
  }

  public onDeleteCourier(field: EnumDedicatedType, index: number): void {
    this[field].splice(index, 1)
    this.fetchCourier();
  }

  public onDeletePOS(field: EnumDedicatedType, index: number): void {
    this[field].splice(index, 1);
    this.fetchPOS(true);
  }

  private onBack(): void {
    this.modalSuccessVisible = false
    this.$router.push('/offer/manage-courier-dedicated')
  }

  public onCourierSearch(query: string): void {
    this.courierParameters.q = query
    this.filterCourier()
  }

  public onPOSSearch(query: string): void {
    this.posParameters.search = query;
    this.filterPOS()
  }

  private onChangeMultiselect(value: Array<number>): void {
    this.hasChanged.location = true
    this.form.location = value
  }

  public onCloseSelect(field: EnumDedicatedType, index: number) {
    this[field][index].open = false;
    this.fetchPOS(true);
  }

  public onOpenSelect(field: EnumDedicatedType, index: number) {
    this[field][index].open = true;
  }

  private onInputAreaName(): void {
    this.hasChanged.name = true
    dedicatedController.setIsAreaNameExist(false)
  }

  public onClickSubmit(): void {
    if (!this.isFormValid) return;
    this.modalDescription = `Pastikan data nama wilayah & kurir & untuk area ${this.form.areaName} telah sesuai`
    this.modalConfirmVisible = true
  }

  private onSubmit(): void {
    this.modalConfirmVisible = false
    let geoIds: Array<number> = []

    this.geoAddressMainList.map(item => {
      if (item.getGeoAddressIds().length !== 0) {
        geoIds.push(...item.getGeoAddressIds())
      }
    })

    if (this.isFormValid) {
      const payload = new ManageCourierDedicatedApiRequestV2({
        area_name: this.form.areaName.trim(),
        geo_address_id: this.form.location,
        dedicated_mp: this.dedicatedMP.filter(d => !!d.value?.value).map(d => ({
          ref_id: d.value!.value,
          assignee: d.assignee
        })),
        dedicated_ca: this.dedicatedCA.filter(d => !!d.value?.value).map(d => ({
          ref_id: d.value!.value,
          assignee: d.assignee
        })),
        dedicated_client: this.dedicatedClient.filter(d => !!d.value?.value).map(d => ({
          ref_id: d.value!.value,
          assignee: d.assignee
        })),
        dedicated_corporate_mobil: this.dedicatedCorporateMobil.filter(d => !!d.value?.value).map(d => ({
          ref_id: d.value!.value,
          assignee: d.assignee,
          is_special_handling: d.specialHandling
        })),
        dedicated_corporate_motor: this.dedicatedCorporateMotor.filter(d => !!d.value?.value).map(d => ({
          ref_id: d.value!.value,
          assignee: d.assignee,
          is_special_handling: d.specialHandling
        })),
        offer_type: <string>this.form.offerMethod.value,
        is_active: <boolean>this.form.status.value,
      })
      this.dedicatedController.createV2(payload)
    }
  }

  private checkSelectedOption(data: IOptions): boolean {
    return !(data === undefined || data.value === undefined)
  }

  private locationMapper(data: GeoAddress): ILocation {
    return {
      name: data.name || '',
      isChecked: false,
      geoAddressId: data.geoAddressId ? String(data.geoAddressId) : '',
      isParentNotHidden: false,
      setParentNotHidden(state: boolean): void {
        this.children.forEach((child) => {
          child.isParentNotHidden = state
          child.setParentNotHidden(state)
        })
      },
      isNotHidden(keyword: string): boolean {
        const find = (item: ILocation) => item.isNotHidden(keyword)

        if (this.name.toUpperCase().includes(keyword.toUpperCase())) {
          this.setParentNotHidden(true)
          return true
        } else {
          if (this.isParentNotHidden) {
            return true
          } else {
            this.setParentNotHidden(false)
          }
        }

        return (
          this.isParentNotHidden ||
          this.name.toUpperCase().includes(keyword.toUpperCase()) ||
          (this.children && this.children.some(find))
        )
      },
      isDisabled(): boolean {
        if (data.areaId && data.areaId !== 0) {
          return true
        } else if (data.children && data.children.length !== 0) {
          let childDisabledCount = 0

          this.children.forEach(child => {
            if (child.isDisabled()) {
              childDisabledCount++
            }
          })

          if (childDisabledCount === this.children.length) {
            return true
          }
        }

        return false
      },
      getGeoAddressIds(): Array<number> {
        if (this.isChecked && !this.isDisabled()) {
          if (data.geoAddressId && data.geoAddressId !== 0) {
            return [data.geoAddressId]
          } else if (data.children && data.children.length !== 0) {
            let geoIds: Array<number> = []

            this.children.forEach(child => {
              geoIds.push(...child.getGeoAddressIds())
            })

            return geoIds
          }
        } else if (data.children && data.children.length !== 0) {
          let geoIds: Array<number> = []

          this.children.forEach(child => {
            geoIds.push(...child.getGeoAddressIds())
          })

          return geoIds
        }

        return []
      },
      setIsChecked(state: boolean): void {
        this.isChecked = state
      },
      setCheckedNested(state: boolean): void {
        this.isChecked = state

        if (this.children.length !== 0) {
          this.children.forEach(item => {
            item.setCheckedNested(state)
          })
        }
      },
      children: data.children
        ? data.children.map(child => {
            return this.locationMapper(child)
          })
        : [],
    }
  }

  @Validations()
  validations(): Record<string, unknown> {
    return {
      form: {
        areaName: {
          required,
          minLength: minLength(3),
          maxLength: maxLength(50),
        },
        location: { required },
        offerMethod: {
          isNotEmpty: (value: IOptions) => this.checkSelectedOption(value),
        },
        status: {
          isNotEmpty: (value: IOptions) => this.checkSelectedOption(value),
        },
      },
      dedicatedMP: {
        $each: {
          value: {
            value: {
              required: requiredIf((field: IOptions) => {
                if (!field) return true
                return false
              })
            }
          }
        }
      },
      dedicatedCA: {
        $each: {
          value: {
            value: {
              required: requiredIf((field: IOptions) => {
                if (!field) return true
                return false
              })
            }
          }
        }
      },
      dedicatedClient: {
        $each: {
          value: {
            value: {
              required: requiredIf((field: IOptions) => {
                if (!field) return true
                return false
              })
            }
          }
        }
      },
      dedicatedCorporateMobil: {
        $each: {
          value: {
            value: {
              required: requiredIf((field: IOptions) => {
                if (!field) return true
                return false
              })
            }
          }
        }
      },
      dedicatedCorporateMotor: {
        $each: {
          value: {
            value: {
              required: requiredIf((field: IOptions) => {
                if (!field) return true
                return false
              })
            }
          }
        }
      },
    }
  }

  @Watch('courierController.manageCourierAdjustSaldoData')
  setManageCourierData(data: Array<ManageCourierAdjustSaldo>): void {
    const resultMP: IOptions[] = []
    const resultCA: IOptions[] = []
    const resultClient: IOptions[] = []
    const resultCorporateMobil: IOptions[] = []
    const resultCorporateMotor: IOptions[] = []
    let existingIdsMP: Array<number> = []
    let existingIdsCA: Array<number> = []
    let existingIdsClient: Array<number> = []
    let existingIdsCorporateMobil: Array<number> = []
    let existingIdsCorporateMotor: Array<number> = []

    this.dedicatedMP.filter(item => !!item.value?.value).forEach(item => {
      if (item) existingIdsMP.push(<number>item.value!.value)
    })

    this.dedicatedCA.filter(item => !!item.value?.value).forEach(item => {
      if (item) existingIdsCA.push(<number>item.value!.value)
    })

    this.dedicatedClient.filter(item => !!item.value?.value).forEach(item => {
      if (item) existingIdsClient.push(<number>item.value!.value)
    })

    this.dedicatedCorporateMobil.filter(item => !!item.value?.value).forEach(item => {
      if (item) existingIdsCorporateMobil.push(<number>item.value!.value)
    })

    this.dedicatedCorporateMotor.filter(item => !!item.value?.value).forEach(item => {
      if (item) existingIdsCorporateMotor.push(<number>item.value!.value)
    })

    data.forEach((courier: ManageCourierAdjustSaldo) => {
      if (courier.courierId && !existingIdsMP.includes(courier.courierId)) {
        const label = `[${courier.courierId}] ${courier.fullName} (${courier.announcementCourierType}) ${courier.phoneNumber} • ${courier.partnerName}`
        const value = courier.courierId

        if (label && value) {
          resultMP.push({
            label: label,
            value: value,
          })
        }
      }

      if (courier.courierId && !existingIdsCA.includes(courier.courierId)) {
        const label = `[${courier.courierId}] ${courier.fullName} (${courier.announcementCourierType}) ${courier.phoneNumber} • ${courier.partnerName}`
        const value = courier.courierId

        if (label && value) {
          resultCA.push({
            label: label,
            value: value,
          })
        }
      }

      if (courier.courierId && !existingIdsClient.includes(courier.courierId)) {
        const label = `[${courier.courierId}] ${courier.fullName} (${courier.announcementCourierType}) ${courier.phoneNumber} • ${courier.partnerName}`
        const value = courier.courierId

        if (label && value) {
          resultClient.push({
            label: label,
            value: value,
          })
        }
      }

      if (courier.courierId && !existingIdsCorporateMobil.includes(courier.courierId)) {
        const label = `[${courier.courierId}] ${courier.fullName} (${courier.announcementCourierType}) ${courier.phoneNumber} • ${courier.partnerName}`
        const value = courier.courierId

        if (label && value) {
          resultCorporateMobil.push({
            label: label,
            value: value,
          })
        }
      }

      if (courier.courierId && !existingIdsCorporateMotor.includes(courier.courierId)) {
        const label = `[${courier.courierId}] ${courier.fullName} (${courier.announcementCourierType}) ${courier.phoneNumber} • ${courier.partnerName}`
        const value = courier.courierId

        if (label && value) {
          resultCorporateMotor.push({
            label: label,
            value: value,
          })
        }
      }
    })

    if (this.courierParameters.driverType === EnumCourierTypeParams.POS) {
      this.courierOptionsMP = resultMP
      this.courierOptionsCA = resultCA
      this.courierOptionsClient = resultClient
      this.courierOptionsCorporateMobil = resultCorporateMobil
      this.courierOptionsCorporateMotor = resultCorporateMotor
      this.fetchCourier(true, EnumCourierTypeParams.KVP)
    } else if (
      this.courierParameters.driverType === EnumCourierTypeParams.KVP
    ) {
      this.courierOptionsMP.push(...resultMP)
      this.courierOptionsCA.push(...resultCA)
      this.courierOptionsClient.push(...resultClient)
      this.courierOptionsCorporateMobil.push(...resultCorporateMobil)
      this.courierOptionsCorporateMotor.push(...resultCorporateMotor)
      this.courierParameters.driverType = ''
    }
  }

  @Watch('POSController.posData')
  setPartners(data: POS[]) {
    const existingIdsMP = this.dedicatedMP.filter(pos => !!pos?.value?.value && pos.assignee === 'POS').map((pos) => pos.value!.value);
    const existingIdsCA = this.dedicatedCA.filter(pos => !!pos?.value?.value && pos.assignee === 'POS').map((pos) => pos.value!.value);
    const existingIdsClient = this.dedicatedClient.filter(pos => !!pos?.value?.value && pos.assignee === 'POS').map((pos) => pos.value!.value);
    const existingIdsCorporateMobil = this.dedicatedCorporateMobil.filter(pos => !!pos?.value?.value && pos.assignee === 'POS').map((pos) => pos.value!.value);
    const existingIdsCorporateMotor = this.dedicatedCorporateMotor.filter(pos => !!pos?.value?.value && pos.assignee === 'POS').map((pos) => pos.value!.value);

    this.posOptionsMP = data.filter(pos => !existingIdsMP.includes(pos.id)).map((pos) => ({
      label: `${pos.name} [${pos.code}]`,
      value: pos.id,
    }))

    this.posOptionsCA = data.filter(pos => !existingIdsCA.includes(pos.id)).map((pos) => ({
      label: `${pos.name} [${pos.code}]`,
      value: pos.id,
    }))

    this.posOptionsClient = data.filter(pos => !existingIdsClient.includes(pos.id)).map((pos) => ({
      label: `${pos.name} [${pos.code}]`,
      value: pos.id,
    }))

    this.posOptionsCorporateMobil = data.filter(pos => !existingIdsCorporateMobil.includes(pos.id)).map((pos) => ({
      label: `${pos.name} [${pos.code}]`,
      value: pos.id,
    }))

    this.posOptionsCorporateMotor = data.filter(pos => !existingIdsCorporateMotor.includes(pos.id)).map((pos) => ({
      label: `${pos.name} [${pos.code}]`,
      value: pos.id,
    }))
  }

  @Watch('dedicatedController.dataGeoAddressList')
  setGeoAddresses(data: Array<GeoAddress>): void {
    if (data) {
      const mapRes: Array<ILocation> = data.map(
        (item): ILocation => {
          return this.locationMapper(item)
        }
      )

      this.geoAddressMainList = mapRes
    }
  }

  @Watch('dedicatedController.isSuccessCreateManageCourierDedicated')
  setSuccessCreateManageCourierDedicated(data: boolean): void {
    if (data) {
      this.modalSuccessVisible = true
    }
  }

  @Watch('form.areaName')
  onChangeAreaName(data: string): void {
    // remove script tags
    this.form.areaName = Utils.removeScriptTags(data)

    // remove special characters
    this.form.areaName = Utils.removeSpecialCharacters(this.form.areaName)

    // remove html tags
    this.form.areaName = Utils.removeHTMLTags(this.form.areaName)
  }

  beforeDestroy(): void {
    dedicatedController.setIsAreaNameExist(false)
    dedicatedController.setIsSuccessCreateManageCourierDedicated(false)
  }
}
export default CreateManageCourierDedicatedPage
